import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../Button';
import IconClose from '../../../../svg/icons/ic_close_alt_42x42.svg';
import Spacer from '../../../Spacer';
import TranslationProvider, { getTranslation } from '../../../../providers/TranslationProvider';

const AccountRemoveCard = ({ onAbort, onComplete }) => (
  <>
    <Button
      variant="no-style"
      className="AnnouncementModal__icon-close"
      onClick={onAbort}
      data-test-id="announcement_modal-button-close"
      aria-label={getTranslation({ translationKey: 'close', fallback: 'Close' })}
    >
      <IconClose
        background={false}
      />
    </Button>
    <div className="AccountModal__body">
      <div id="account_modal_title" className="AccountModal_title">
        <TranslationProvider translationKey="remove_stored_card_question">
          <span>Remove Stored Card?</span>
        </TranslationProvider>
      </div>
      <div id="account_modal_subtitle" className="AccountModal_subtitle">
        <TranslationProvider translationKey="this_cannot_be_undone">
          <span>This cannot be undone.</span>
        </TranslationProvider>
      </div>
    </div>
    <Spacer height="30" />
    <div className="AccountModal__buttons">
      <Button
        type="button"
        className="AccountPaymentMethodRow__default-button"
        onClick={onAbort}
        variant="no-style"
      >
        <TranslationProvider translationKey="cancel">
          <span>Cancel</span>
        </TranslationProvider>
      </Button>
      <Button
        type="button"
        className="AccountPaymentMethodRow__remove-button"
        onClick={onComplete}
        variant="no-style"
      >
        <TranslationProvider translationKey="remove">
          <span>Remove</span>
        </TranslationProvider>
      </Button>
    </div>
  </>
);

AccountRemoveCard.propTypes = {
  onAbort: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
};

export default AccountRemoveCard;
